import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Restores focus to the element that opened a sub-flow. The sub-flow navigates
 * back with `state: { focusElementId }` (e.g. TestSessionPage after Save or
 * Cancel), and this moves focus to that element once it is in the DOM.
 */
export function useReturnFocus(): void {
  const location = useLocation();
  const focusElementId = (location.state as { focusElementId?: unknown } | null)?.focusElementId;

  useEffect(() => {
    if (typeof focusElementId !== 'string' || focusElementId === '') return;
    document.getElementById(focusElementId)?.focus();
  }, [focusElementId, location.key]);
}
